import { Injectable } from '@angular/core';
import { Component, OnInit, ViewChild , OnDestroy} from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class GeoService {

  constructor(private http: Http) { }

  getLocation(location: string): Promise<any> {
    return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + location + '&key=' + environment.googleMapsKey)
         .toPromise()
         .then((response) => Promise.resolve(response.json()))
         .catch((error) => Promise.resolve(error.json()));
  }


}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/shared/geo.service.ts